module.exports = __webpack_public_path__ + "img/27t.c0c3fa2c.jpg";